import React from 'react';
import { withRouter } from 'react-router-dom';
import { AppContext } from '../AppContext';
import { validateEmail, validateInput, encodeHTML, isMediaRecorderSupported } from '../AppUtils';
import Job from '../components/Job'
import { RecordEvent } from '../Analytics';

class Step3IMG extends React.Component {
    
    constructor(props) {
        super(props);   

        this.uploading = null;

        this.name = null;
        this.email = null;
        this.phone = null;
        this.overEighteen = null;
        this.mailingList = null;

        this.submitJob = this.submitJob.bind(this);
        this.validateData = this.validateData.bind(this);
        this.validateDataInterval = null;
    }

    componentDidMount() {

        var self = this;

        this.uploading = document.getElementById("ui-upload");
        this.uploading.className = "textcon vid-upload hidden";
        
        this.name = document.getElementById("userName");
        this.email = document.getElementById("userEmail");
        this.phone = document.getElementById("userPhone");
        this.overEighteen = document.getElementById("overEighteen");
        this.mailingList = document.getElementById("mailingList");

        var submitButton = document.getElementById("submitButton");

        this.validateDataInterval = setInterval(function () {
            if (self.validateData()) {
                submitButton.className = "next-button-con";
            } else {
                submitButton.className = "next-button-con unclickable";
            }
        }, 500);        
    }

    validateData() {

        if (this.name.value === "" || !validateInput(this.name.value))
            return false;
        
        if (this.email.value === "" || !validateEmail(this.email.value))
            return false;

        if (this.phone.value === "")
            return false;

        return this.overEighteen.checked;
    }

    async submitJob() {

        var self = this;

        clearInterval(this.validateDataInterval);

        this.uploading.className = "vid-upload";

        var job = new Job();
        job.createJob(encodeHTML(this.name.value), this.email.value, this.phone.value, encodeHTML(this.context.message), this.mailingList.checked, this.context.images, function (data, err) {

            if (err) {
                console.log(err);
                RecordEvent("Error-ErrorCreatingJob");
                return;
            }

            console.log(data);

            self.uploading.className = "textcon vid-upload hidden";
            self.props.history.push('finished');
        });
    }

    render() {
        return (
            <div>
                <img src="img/texture1.png" className="backgroundfill" alt=""/>
                <div className="side-menu ">
                    <div className="cover"></div>
                    <div className="step-menu-con">
                        <img src="img/sid-menu-img.png" alt="exsample gif" srcSet="" className="side-menu-top"/>
                        <div className="center-gold"></div>
                        <h1 >thank you lord</h1>
                        <h3>enhanced video</h3>

                        <div className="textcon">
                            <p>Join Chris Tomlin, Thomas Rhett, and Florida Georgia Line in a :25 clip from “Thank You Lord”!</p>
                            <div className="center-gold"></div>
                        </div>

                        <div className="listcon">
                            <div className="con active">
                                <div className="step">
                                    <div className="stepnumber"><img className="stepimg check" src="img\check.svg" alt=""/></div>
                                </div>
                                <h2 className="step-title">lastly, tell us what you’re thankful for</h2>
                            </div>

                            <div className="con active">
                                <div className="step">
                                    <div className="stepnumber"><img className="stepimg check" src="img\check.svg" alt=""/></div>
                                </div>
                                <h2 className="step-title"> Show what you are thankful for</h2>
                            </div>

                            <div className="con active">
                                <div className="step">
                                    <div className="stepnumber">3</div>
                                </div>
                                <h2 className="step-title"> get your custom music video!</h2>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className="body-con">
                    <br/>

                    <div className="current-step">
                        <div className="line-before"></div>
                        <div className="con step-con">
                            <div className="step">
                                <div className="stepnumber">3</div>
                            </div>
                        </div>
                        <div className="line-after"></div>
                    </div>

                    <h1 className="main-color no-bot-pad">last, tell us a bit<br className="deskhidden"/> about yourself.</h1>
                    
                    <div className="textcon">
                        <p>We’ll need your info to deliver <br className="deskhidden"/>your video when it’s done.</p>
                    </div>

                    <div className="get-info">
                        <div className="input-con">
                            <input id="userName" type="text" required className="text_input-small"/>
                            <label className="label-name-small">
                                <span className="content-name-small">
                                    Name*
                                </span>
                            </label>
                            <div className="input_line"></div>
                            <div className="errortext"> </div>
                        </div>
                        <br/>
                        <div className="input-con">
                            <input id="userEmail" type="email" required className="text_input-small"/>
                            <label className="label-name-small">
                                <span className="content-name-small">
                                    Email*
                                </span>
                            </label>
                            <div className="input_line"></div>
                            <div className="errortext hidden">Please submit an email address in a valid format</div>
                        </div>
                        <br/>

                        <div className="input-con">

                            <input id="userPhone" type="phone" required className="text_input-small"/>
                            <label className="label-name-small">
                                <span className="content-name-small">
                                    Phone*
                                </span>
                            </label>
                            <div className="input_line"></div>
                            <div className="errortext"></div>
                        </div>
                    </div>
                    <br/>
                    <br className="deskhidden"/>

                    <div className="legal-con-full">
                        <label className="legal-con">
                            I am over 18 years of age* 
                            <input id="overEighteen" type="checkbox"/>
                            <span className="checkmark"></span>
                        </label>

                        <label  className="legal-con">
                            I’d like to join Chris Tomlin's mailing list to learn about upcoming singles, videos, and concerts. 
                            <input id="mailingList" type="checkbox"/>
                            <span className="checkmark"></span>
                        </label>

                        <br/>

                        <p className="legal fine">Submitting means that you have read and agree to the <a href="https://privacy.umusic.com/terms/" target="_blank" 
                            data-amplify-analytics-on='click'
                            data-amplify-analytics-name='click'
                            data-amplify-analytics-attrs='attr:Step3-Terms'>Terms and Conditions</a>,   <a href="https://privacy.umusic.com/" target="_blank" 
                            data-amplify-analytics-on='click'
                            data-amplify-analytics-name='click'
                            data-amplify-analytics-attrs='attr:Step3-Privacy'>Privacy Policy</a>.
                        </p>
                    </div>

                    <div id="submitButton" className="next-button-con" onClick={this.submitJob} 
                            data-amplify-analytics-on='click'
                            data-amplify-analytics-name='click'
                            data-amplify-analytics-attrs='attr:Step3-Submit'>
                        <div className="line-before"></div>
                        <div className="next-button">
                            <div className="nexr-button-innercon">
                                <div className="next-button-text">submit & FINISH</div>
                                <div className="next-button-arrow"><img src="img/arrow-right.svg" alt=""/></div>
                            </div>
                        </div>
                        <div className="line-after"></div>
                    </div>

                    <div id="ui-upload" className="vid-upload">

                        <div>
                        <h1 className="main-color">uploading…</h1>
                        <p>This may take a moment depending <br/> on the speed of your connection.</p>
                        <p>Please wait until you are redirected <br/> to the final page before leaving.</p>
                        <div className="con-audio">
                            <div id="play-bar"></div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Step3IMG.contextType = AppContext;
export default withRouter(Step3IMG);